import { motion, useReducedMotion } from 'motion/react'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { duration, ease } from '../../lib/motion'

const stagger = {
  visible: { transition: { staggerChildren: 0.07 } },
}

const item = {
  hidden: { opacity: 0, y: 12, filter: 'blur(6px)' },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { duration: duration.slow, ease: ease.standard },
  },
}

/** Same content, no motion. Only opacity changes for users who asked for it. */
const itemReduced = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: duration.slow, ease: ease.standard } },
}

export default function Hero() {
  const prefersReducedMotion = useReducedMotion()
  const itemVariants = prefersReducedMotion ? itemReduced : item

  const scrollToDemo = () => {
    document
      .getElementById('how-it-works-demo')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <section className="relative">
      <div className="mx-auto max-w-6xl px-4 pb-20 pt-24 md:pb-28 md:pt-36">
        <motion.div initial="hidden" animate="visible" variants={stagger} className="max-w-3xl">
          <motion.h1
            variants={itemVariants}
            className="text-balance text-[2.7rem] font-semibold leading-[0.94] tracking-[-0.042em] text-white md:text-hero"
          >
            <span className="relative inline-block">
              <span
                aria-hidden
                className="absolute -inset-x-6 inset-y-2 -z-10 rounded-full bg-primary-400/20 blur-3xl"
              />
              Your meeting notes
            </span>
            <br />
            are already a list
            <br />
            of tasks
          </motion.h1>

          <motion.p variants={itemVariants} className="mt-8 max-w-xl text-body-lg text-white/50">
            Paste a transcript. notes2board pulls out the action items with their
            owner, deadline and priority, and puts them on your Trello board.
          </motion.p>

          <motion.div
            variants={itemVariants}
            className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center"
          >
            <Link
              to="/auth"
              className="inline-flex items-center gap-2 rounded-lg bg-white px-5 py-3 text-body font-medium text-surface-base transition-[transform,opacity] duration-150 ease-out hover:opacity-90 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-surface-base"
            >
              Start free
              <ArrowRight className="h-4 w-4" />
            </Link>
            <button
              type="button"
              onClick={scrollToDemo}
              className="rounded-lg px-1 py-3 text-body text-white/50 underline-offset-4 transition-colors hover:text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
            >
              See how it works
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}
